<template>
  <div>
    <div class="form__items">
      <div class="form__item">
        <v-text-field
          :label="$t('createErrand.tenantName')"
          autocomplete="new-password"
          v-model="place.name"
          :rules="rules.required"
        ></v-text-field>
      </div>

      <div class="form__item">
        <v-text-field
          :label="translateOptional('email')"
          autocomplete="new-password"
          v-model="place.email"
          :rules="rules.email"
        ></v-text-field>
      </div>
    </div>

    <div class="form__items">
      <div class="form__item">
        <v-text-field
          :label="$t('createErrand.phoneNumber')"
          autocomplete="new-password"
          v-model="place.phone_number"
          :rules="rules.phone"
        ></v-text-field>
      </div>

      <div class="form__item">
        <v-text-field
          :label="translateOptional('alternativePhoneNumber')"
          autocomplete="new-password"
          v-model="place.mobile_phone"
          :rules="rules.optionalPhone"
        ></v-text-field>
      </div>
    </div>

    <div class="form__items">
      <div class="form__item">
        <PolygonAddressField
          :rules="rules.required"
          :eventKey="eventKey"
        />
      </div>
    </div>

    <div class="form__items">
      <div class="form__item">
        <v-text-field
          :label="$t('createErrand.city')"
          :disabled="!!placeId"
          v-model="address.city"
          autocomplete="new-password"
          :rules="rules.city"
        ></v-text-field>
      </div>

      <div class="form__item">
        <v-text-field
          :label="$t('createErrand.postalCode')"
          :disabled="!!placeId"
          v-model="address.zip_code"
          autocomplete="new-password"
          :rules="rules.postalCodeRule"
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['rules', 'translateOptional', 'eventKey', 'placeId'],
  data: () => ({
    place: {
      name: null,
      phone_number: null,
      mobile_phone: null,
      email: null
    },
    address: {
      city: null,
      zip_code: null
    }
  }),
  mounted() {
    this.subscribe(`update.newerrand.address.${this.eventKey}`, address => {
      _.assignIn(this.address, address)
    })
  },
  watch: {
    placeId(current, previous) {
      if (!current && previous) {
        this.address.city = ''
        this.address.zip_code = ''
      }
    },
    place: {
      deep: true,
      handler(place) {
        this.publish(`newerrand.place.${this.eventKey}.updated`, place)
      }
    },
    address: {
      deep: true,
      handler(address) {
        this.publish(`newerrand.address.${this.eventKey}.updated`, address)
      }
    }
  }
}
</script>
